(() => {
  'use strict';
  if (window.LMDGiftCart) return;
  const giftId = 52432992960779;
  const root = window.Shopify?.routes?.root || '/';
  const rawFetch = window.fetch.bind(window);
  let queue = Promise.resolve();
  let declined = false;
  try { declined = sessionStorage.getItem('lmd-gift-declined') === '1'; } catch (_) {}
  const enqueue = task => {
    const result = queue.then(task);
    queue = result.catch(() => {});
    return result;
  };
  function decline(value) {
    declined = value;
    try { sessionStorage.setItem('lmd-gift-declined', value ? '1' : '0'); } catch (_) {}
  }
  async function readCart() {
    const response = await rawFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  function netTotal(cart) {
    const gifts = cart.items.filter(item => item.variant_id === giftId);
    return Math.max(0, cart.total_price - gifts.reduce((sum, item) => sum + item.final_line_price, 0));
  }
  function propertiesEqual(a, b) {
    const entries = value => Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b));
    return JSON.stringify(entries(a)) === JSON.stringify(entries(b));
  }
  async function syncGift(cart, sections, sectionsUrl) {
    const eligible = netTotal(cart) > 10000;
    if (!eligible) decline(false);
    const giftLines = cart.items.filter(item => item.variant_id === giftId);
    const current = giftLines.reduce((sum, item) => sum + item.quantity, 0);
    const desired = eligible && !declined ? 1 : 0;
    if (current === desired) return { cart, changed: false };
    const updates = {};
    giftLines.forEach((item, index) => { updates[item.key] = index === 0 ? desired : 0; });
    if (!giftLines.length && desired) updates[String(giftId)] = 1;
    const response = await rawFetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: sectionsUrl || location.pathname })
    });
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error(result.description || result.errors || 'Gift update failed');
    return { cart: result, changed: true };
  }
  window.LMDGiftCart = { netTotal };
  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : input?.url || String(input);
    if (!/\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) return rawFetch(input, init);
    return enqueue(async () => {
      let payload;
      try { if (typeof init?.body === 'string') payload = JSON.parse(init.body); } catch (_) {}
      let nextInit = init;
      let manualGiftRemoval = false;
      if (/\/cart\/change(?:\.js)?(?:\?|$)/.test(url) && payload?.id) {
        const current = await readCart();
        let item = current.items.find(item => item.key === String(payload.id));
        if (!item && init?.lmdIdentity) {
          const identity = init.lmdIdentity;
          item = current.items.find(item => item.variant_id === identity.variantId &&
            propertiesEqual(item.properties, identity.properties) &&
            (item.selling_plan_allocation?.selling_plan?.id || null) === identity.sellingPlan);
        }
        if (item) payload.id = item.key;
        manualGiftRemoval = item?.variant_id === giftId && Number(payload.quantity) === 0;
        nextInit = { ...init, body: JSON.stringify(payload) };
        delete nextInit.lmdIdentity;
      }
      const response = await rawFetch(input, nextInit);
      if (!response.ok) return response;
      let original;
      try { original = await response.clone().json(); } catch (_) { return response; }
      if (original.errors) return response;
      if (manualGiftRemoval) decline(true);
      const sections = payload?.sections || Object.keys(original.sections || {});
      let result;
      try { result = await syncGift(await readCart(), sections, payload?.sections_url); }
      catch (error) {
        // The requested cart operation succeeded. Preserve its response so that
        // the customer sees the real cart and cannot accidentally repeat it.
        console.warn('[LMD gift] Synchronisation du cadeau indisponible', error);
        return response;
      }
      if (!result.changed) return response;
      const state = /\/cart\/add/.test(url) ? { ...original, sections: result.cart.sections } : result.cart;
      return new Response(JSON.stringify(state), {
        status: response.status, statusText: response.statusText, headers: { 'Content-Type': 'application/json' }
      });
    });
  };
  async function initialise() {
    try {
      await enqueue(async () => {
        const sections = ['cart-drawer', 'cart-icon-bubble'];
        const mainItems = document.getElementById('main-cart-items');
        const mainFooter = document.getElementById('main-cart-footer');
        if (mainItems?.dataset.id) sections.push(mainItems.dataset.id);
        if (mainFooter?.dataset.id) sections.push(mainFooter.dataset.id);
        const { cart, changed } = await syncGift(await readCart(), sections, location.pathname);
        if (!changed) return;
        const replacements = [
          ['cart-drawer', '#CartDrawer', '#CartDrawer'],
          ['cart-icon-bubble', '#cart-icon-bubble', '.shopify-section'],
          [mainItems?.dataset.id, '#main-cart-items .js-contents', '.js-contents'],
          [mainFooter?.dataset.id, '#main-cart-footer .js-contents', '.js-contents']
        ];
        for (const [section, targetSelector, sourceSelector] of replacements) {
          const target = document.querySelector(targetSelector);
          const html = cart.sections?.[section];
          if (!target || !html) continue;
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
          if (source) target.innerHTML = source.innerHTML;
        }
        document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
      });
    } catch (error) { console.warn('[LMD gift]', error); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
